import Image from 'next/image';
import { Menu } from './menu';
import { CreatePackButton, DeleteWarningBanner } from 'components';
import { UserMenu } from './userMenu';
import { ManageTeamInvitesButton } from 'domains/team';
import { Grid, GridItem, Box } from '@chakra-ui/layout';
import Link from 'next/link';
import { Search } from './search';
import { SearchButton } from './search-button';
import { useState } from 'react';
import { Flex, useBreakpointValue } from '@chakra-ui/react';
import getConfig from 'next/config';
import { useAppSelector } from 'lib/redux';
import { selectMe } from 'domains/account';
import { useRouter } from 'next/router'
import { UpgradeButton } from "components/stripe";
import { isPreviewingPack } from "lib/utils";
import { useLoggedinUser } from "lib/hooks";
import { PermissionLevels } from 'lib/types';

const { publicRuntimeConfig: { baseProtocol, baseDomain }} = getConfig();

export const Header = () => {
  const [displaySearch, setDisplaySearch] = useState(false);
  const isMobile = useBreakpointValue([true, true, false]);
  const isHidden = displaySearch && isMobile;
  const me = useAppSelector(selectMe);
  const router = useRouter();
  const { isLoggedIn } = useLoggedinUser();

  const isPreviewing = isPreviewingPack(router.pathname);
  const isAdmin = isLoggedIn && (me.permissions === PermissionLevels.ADMIN || me.permissions === PermissionLevels.OWNER);
  const showControls = router.pathname !== '/packs/[id]' || isLoggedIn;

  if (isHidden) {
    return (
      <Box position="fixed" top="0" right="0" left="0" zIndex="1000">
        <Grid
          position="relative"
          alignItems="center"
          bgColor="#FCFCFF"
          gridTemplateColumns="auto"
          padding={['17px 30px 16px', '17px 30px 16px', '20px 30px']}
          borderBottom="1px solid"
          borderColor="border.500"
        >
          <GridItem>
            <Search onClose={() => setDisplaySearch(false)} />
          </GridItem>
        </Grid>
        <Box display={['block', 'block', 'none']} borderBottom="1px solid" borderColor="border.500">
          <Menu />
        </Box>
      </Box>
    );
  }

  const linkToMarketing = !me.permissions && router.asPath.startsWith('/packs/x');

  return (
    <Box position="fixed" top="0" right="0" left="0" zIndex="1000">
      <DeleteWarningBanner />
      <Grid
        position="relative"
        alignItems="center"
        bgColor="#FCFCFF"
        gridTemplateColumns={['100px auto', '135px auto']}
        gap="20px"
        padding={['10px', '10px', '20px 30px']}
        borderBottom="1px solid"
        borderColor="border.500"
      >
        <GridItem>
          <Grid
            gap={[0, 0, '40px']}
            gridTemplateColumns={['100px auto', '135px auto']}
            alignItems="center"
            justifyContent="space-between"
          >
            <Link href={linkToMarketing ? `${baseProtocol}://${baseDomain}` : '/packs'} passHref>
              <a><Image src="/packs-logo-horizontal.svg" alt="Packs logo" width={135} height={47} /></a>
            </Link>
            <Box display={['none', 'none', 'block']}>
              {!displaySearch && !isPreviewing && showControls && <Menu />}
            </Box>
          </Grid>
        </GridItem>
        <GridItem>
          <Flex justifyContent={"flex-end"} gap={3} alignItems={"center"}>
            {(!displaySearch && !isPreviewing && showControls) ? <SearchButton onClick={() => setDisplaySearch(true)} /> : null}
            {(displaySearch && !isPreviewing && showControls) ? <Search onClose={() => setDisplaySearch(false)} /> : null}
            {!displaySearch && isAdmin && !isPreviewing && <ManageTeamInvitesButton />}
            {(!displaySearch && !isPreviewing && showControls) ? <CreatePackButton /> : null}
            {!displaySearch && !isPreviewing && isAdmin && <UpgradeButton />}
            <UserMenu />
          </Flex>
        </GridItem>
      </Grid>
      <Box display={['block', 'block', 'none']} borderBottom="1px solid" borderColor="border.500">
        <Menu />
      </Box>
    </Box>
  )
}
